export default __webpack_public_path__ + "static/affordable-43beec0a51dfc417977edbdb78a0f0f4.png";